import httpRequest from 'httpRequest'
import { TableSlimModel } from 'models'

const PREFIX = '/location/tables'

const tableService = {
    getAllTables() {
        return httpRequest.get<TableSlimModel[]>(PREFIX)
    },
    onBilledTable(tableId: string) {
        return httpRequest.put(`${PREFIX}/billed/${tableId}`)
    },
}

export default tableService
